import { render, staticRenderFns } from "./NewBulletin.vue?vue&type=template&id=28e8500c&scoped=true&"
import script from "./NewBulletin.vue?vue&type=script&lang=js&"
export * from "./NewBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8500c",
  null
  
)

export default component.exports